import { StringUtils } from "./string-utils";

export class DateUtils {
	public static removeTime(date: Date): Date {
		return new Date (date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	}

	public static convDateISO(value: Date): string {
		if (!value) {
			return null;
		}

		let dd = value.getDate();
		let mm = value.getMonth()+1;
		let yyyy = value.getFullYear();

		//"invalid date", alguns navegadores retornam este valor quando o campo fica vazio
		if (Number.isNaN(dd) || Number.isNaN(mm) || Number.isNaN(yyyy)) {
			return null;
		}

		return yyyy
			+ "-" + StringUtils.padLeft(mm, 2)
			+ "-" + StringUtils.padLeft(dd, 2);
	}

	public static convTimeISO(value: Date): string {
			if (!value) {
				return null;
			}

			let hh = value.getHours();
			let mm = value.getMinutes();
			let ss = value.getSeconds();
			let ms = value.getMilliseconds();

			//"invalid date", alguns navegadores retornam este valor quando o campo fica vazio
			if (Number.isNaN(hh) || Number.isNaN(mm) || Number.isNaN(ss) || Number.isNaN(ms)) {
				return null;
			}

			return  StringUtils.padLeft(hh, 2)
				+ ":" + StringUtils.padLeft(mm, 2)
				+ ":" + StringUtils.padLeft(ss, 2)
				+ "." + StringUtils.padLeft(ms, 4);
	}

	/**
	 * O Constructor Date(data) usa timezone UTC se utilizado no formato ISO,
	 * e isso acaba alterando a data para o dia anterior;
	 * Formato: yyyy-MM-dd;
	 */
	public static parseLocalISO(value: string): Date {
		if (!value) {
			return null;
		}
		let s = value.split("-");
		return new Date(+s[0], +s[1] - 1, +s[2]);
	}

	/**
	 * Formato ISO - HH:mm:ss;
	 */
	public static parseTimeISO(value: string): Date {
		if (!value) {
			return null;
		}
		let s = value.split(/[:.]/);
		let d = new Date();
		d.setHours(+s[0]);
		d.setMinutes(+s[1]);
		d.setSeconds(s[2] ? +s[2] : 0);
		d.setMilliseconds(s[3] ? +s[3] : 0);
		return d;
	}

	public static validaIntervalo (ini: Date, fin: Date): boolean {
		if (ini == null || fin == null) {
			throw new Error("Data não pode ser vazia.");
		}

		if (ini > fin) {
			throw new Error("A data final deve ser maior ou igual a data inicial.");
		}

		return true;
	}
}